<template>
 <div>
  点击查询 
 </div>
</template>

<script>
 export default {
   name: 'clickCheck',
   data () {
     return {

     }
   },
   components: {

   }
 }
</script>

<style>

 
</style>



// WEBPACK FOOTER //
// src/components/home/components/components/check/clickCheck.vue